<template>
  <label class="checkbox-pic" :style="{backgroundColor: value ? activeColor : '#bcbcbc'}">
    <img :src="require(`@/assets/img/${picPath}`)" alt="Pic">
    <input
      type="checkbox"
      :checked="value"
      @change="$emit('change', $event.target.checked)"
      :name="name"
    />
  </label>
</template>

<script>
export default {
  name: 'AppCheckboxPic',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: [String, Boolean],
    activeColor: String,
    picPath: String,
    name: String,
  },
}
</script>

<style lang="sass">
.checkbox-pic
  width: 25px
  height: 25px
  background-repeat: no-repeat
  background-position: center
  border-radius: 9px
  display: flex
  align-items: center
  justify-content: center
  position: relative
  cursor: pointer
  user-select: none
  transition: background-color 0.3s

  input
    +visually-hidden
</style>
